// extracted by mini-css-extract-plugin
module.exports = {"VideoWrapper":"VideoPlayerAspect_VideoWrapper__LIvTH"};